import { useApi } from "../../lib/api";
import { Loading } from "../common";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import FinanceSummary from "./FinanceSummary";
import QuotesTab from "./QuotesTab";
import EntryTab from "./EntryTab";

const TABS = [["riepilogo", "Cruscotto"], ["preventivi", "Preventivi"], ["varianti", "Varianti"], ["costi", "Acquisti e spese"], ["incassi", "Incassi cliente"]];

export default function FinancePanel({ siteId }) {
  const { data, reload } = useApi(`/finance/sites/${siteId}`);
  if (!data) return <Loading />;
  return (
    <Tabs defaultValue="riepilogo" data-testid="finance-panel">
      <TabsList className="mb-4 flex-wrap h-auto">
        {TABS.map(([v, l]) => <TabsTrigger key={v} value={v} data-testid={`fin-subtab-${v}`}>{l}</TabsTrigger>)}
      </TabsList>
      <TabsContent value="riepilogo"><FinanceSummary s={data.summary} /></TabsContent>
      <TabsContent value="preventivi"><QuotesTab siteId={siteId} quotes={data.quotes} reload={reload} /></TabsContent>
      <TabsContent value="varianti"><EntryTab entity="variations" siteId={siteId} items={data.variations} reload={reload} /></TabsContent>
      <TabsContent value="costi"><EntryTab entity="purchases" siteId={siteId} items={data.purchases} reload={reload} /></TabsContent>
      <TabsContent value="incassi"><EntryTab entity="invoices" siteId={siteId} items={data.invoices} reload={reload} /></TabsContent>
    </Tabs>
  );
}
